/**
 * Sidebar Resolution filter: binds RmaListFiltersStore resolution draft to
 * RmaListFilterControl via filterControlDataProps (grouped single-select radio list).
 */
import { observer } from "mobx-react";
import useDashboardTranslation from "../../../../../../../dashboard-translation/hooks/dashboard-translation-hook";
import RmaListFiltersStore from "../../../../../rma-list-page/stores/rma-list-filters-store";
import {
    MANAGE_RETURNS_DESIGN_VERSION,
    trackManageReturnsListEvent,
} from "../../../../../utils/manage-returns-list-mixpanel";
import { RMA_LIST_FILTER_CONTROL_DATA_TYPE } from "../rma-list-filter-control/components/rma-list-filter-control-portal/rma-list-filter-control-content/rma-list-filter-control-content";
import RmaListFilterControl from "../rma-list-filter-control/rma-list-filter-control";

interface IProps {
    rmaListFiltersStore: RmaListFiltersStore;
    disabled?: boolean;
}

const RmaListFilterResolution: React.FC<IProps> = observer(({ rmaListFiltersStore, disabled }) => {
    const { getTranslation } = useDashboardTranslation();
    const scope = "dashboard-returns-page";
    const selectedId = rmaListFiltersStore.selectedResolutionId;

    return (
        <RmaListFilterControl
            label={getTranslation("FILTERS_RESOLUTION_TYPE", scope)}
            selectedLabel={rmaListFiltersStore.selectedResolutionLabel}
            disabled={disabled}
            onOpen={() => trackManageReturnsListEvent("d&_filter_resolutions", MANAGE_RETURNS_DESIGN_VERSION.V2)}
            onClear={() => rmaListFiltersStore.setSelectedResolutionId(null)}
            filterControlDataProps={{
                type: RMA_LIST_FILTER_CONTROL_DATA_TYPE.GROUPED_OPTIONS,
                value: selectedId,
                groups: rmaListFiltersStore.resolutionFilterGroups,
                onChange: (id) => {
                    rmaListFiltersStore.setSelectedResolutionId(Number(id));
                },
            }}
        />
    );
});

export default RmaListFilterResolution;
